import { getProductCodenameFromSubscription } from '@recruitee/billing-plans';
import { BillingPlanTier, Company, PricingFeatureSubscription } from '@recruitee/http-types';

export function getProductCodename(currentCompany: Company): BillingPlanTier | null {
  const currentCompanySubscription = <PricingFeatureSubscription>currentCompany!.subscription;

  return (currentCompany && getProductCodenameFromSubscription(currentCompanySubscription)) || null;
}
